// extracted by mini-css-extract-plugin
export var container = "_34-0";